import React from "react";
import Pagination from "react-js-pagination";
import BtnThemMoi from "./ThemMoi/BtnThemMoi";
import { ContentTable } from "./ContentTable";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload }) => {
    const handlePageChange = (pageNumber) => {
        setDataSearch(prev => ({ ...prev, iPageIndex: pageNumber }));
        onSearch({ ...dataSearch, iPageIndex: pageNumber });
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    return (
        <>
            {isLoading ? (
                <div className="loading-page1">
                    <div className="loader loader-default is-active"></div>
                </div>
            ) : (
                <>
                    <div className="card border-light mb-2 card-v2">
                        <div className="card-body card-body-v2">
                            <div className="row col-sm-12 col-md-12 themoi-taisanthly mb-1">
                                <div className="col-sm-12 col-md-10">
                                    {phanQuyen.themmoi && <BtnThemMoi onReload={onReload} />}
                                </div>
                            </div>
                            <div className="Left808x200 Table-main-new css-table-ds">
                                <div className="table-mobile table-mobile-hover">
                                    <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                        <div className="table-headers">
                                            <div className="custom-table-header flex-basis-5 text-left" style={{ justifyContent: 'center' }}>
                                                <p className="color-do-bold">
                                                    STT
                                                    <br />[{listDanhSach.iTotal}]
                                                </p>
                                            </div>
                                            <div className="custom-table-header flex-basis-25 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Tên loại phiếu</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-15 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Ngày tạo</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-20 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Người tạo</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-10 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Loại</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-15 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Trạng thái</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-10 text-center" style={{ justifyContent: 'center' }}>
                                                <p>Chức năng</p>
                                            </div>
                                        </div>

                                        <div className="custom-table-body">
                                            <ContentTable 
                                                listDanhSach={listDanhSach.List} 
                                                phanQuyen={phanQuyen} 
                                                onReload={onReload}
                                                dataSearch={dataSearch}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card border-light mb-2 card-v2" >
                        <div className="card-body card-body-v2">
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <span className="color7">
                                        {listDanhSach.iTotal === 0 ? (
                                            "Hiển thị 0 - 0 / Tổng số 0"
                                        ) : (
                                            <>
                                                Hiển thị{" "}
                                                {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + 1} -{" "}
                                                {Math.min(
                                                    dataSearch.iPageIndex * dataSearch.iPageSize,
                                                    listDanhSach.iTotal
                                                )}{" "}
                                                / Tổng số {listDanhSach.iTotal}
                                            </>
                                        )}
                                    </span>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div
                                        className={
                                            "paniation-new paniation-new1 d-flex justify-content-center " +
                                            (listDanhSach.iTotal === 0 ? "hidden" : "")
                                        }
                                        style={{ float: "right" }}
                                    >
                                        <nav aria-label="Page navigation">
                                            <Pagination
                                                activePage={dataSearch.iPageIndex}
                                                itemsCountPerPage={dataSearch.iPageSize}
                                                totalItemsCount={listDanhSach.iTotal}
                                                pageRangeDisplayed={5}
                                                onChange={handlePageChange}
                                                itemClass="page-item border-none"
                                                linkClass="page-link border-none"
                                                activeClass="active"
                                            />
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};